module.exports = __webpack_public_path__ + "img/profile-img.8dd28c4f.jpg";